module.exports = __webpack_public_path__ + "img/cover.21a4037c.jpg";